export interface UpdateSenderActiveStatusInterface {
  sender_id: number;
  is_active: boolean;
}

export interface UpdateSenderDeviceVerificationInterface {
  sender_id: number;
  is_device_verification_required: boolean;
}

export interface UpdateSenderKycAmlStatusInterface {
  sender_id: number;
  action: 'KYC' | 'AML';
  value: string; // KYC-OK | KYC-SENT | KYC-NOTOK | AML-OK | AML-SENT | AML-NOTOK
}

export interface UpdateSenderPasswordInterface {
  sender_id: number;
  new_password: string;
}

export interface UpdateSenderPinInterface {
  sender_id: number;
  pin: string;
}

export const KYC_STATUS_OPTIONS = [
  { name: 'KYC OK', value: 'KYC-OK' },
  { name: 'KYC Sent', value: 'KYC-SENT' },
  { name: 'KYC Not OK', value: 'KYC-NOTOK' },
];

export const AML_STATUS_OPTIONS = [
  { name: 'AML OK', value: 'AML-OK' },
  { name: 'AML Sent', value: 'AML-SENT' },
  { name: 'AML Not OK', value: 'AML-NOTOK' },
];
